import React from "react";

import { Text } from "@performyard/py-components";

import { Grid, GridCol } from "../../../components/Grid";
import Spacer from "../../../components/Spacer";

type SectionLayoutProps = {
	title: string;
	description: string;
	children: React.ReactNode;
};

export const SectionLayout = ({ title, description, children }: SectionLayoutProps) => {
	return (
		<Grid cols={10} gap={2}>
			<GridCol span={4}>
				<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
					{title}
				</Text>
				<Spacer height={1} />
				<div className="max-w-[365px]">
					<Text size="paragraph-3" weight="regular" color="neutral-9">
						{description}
					</Text>
				</div>
				<Spacer height={3} />
			</GridCol>

			<GridCol span={1} />

			<GridCol span={5}>
				<Grid cols={5}>{children}</Grid>
			</GridCol>
		</Grid>
	);
};
